module.exports = __webpack_public_path__ + "img/FR14888.d4126f95.png";